<template>
  <Layout>
    <div class="row">
      <div class="col-md-12">
        <b-card>
          <PageHeader :title="title" :items="items" style="margin-top: -30px"/>
          <form action="">
            <div class="form-row">
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="household_number">Household Number</label>
                <input
                        type="text"
                        v-model="search_data.household_number"
                        id="household_number"  name="household_number"
                        placeholder="Search by HH No"
                        class="form-control form-control-sm"
                />
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="name">Household Head Name</label>
                <input
                        type="text"
                        v-model="search_data.name"
                        id="name" name="name"
                        class="form-control form-control-sm"
                        placeholder="Search by Name"
                />
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="c_village_id">Village</label>
                <select
                        v-model="search_data.c_village_id"
                        id="c_village_id"
                        name="c_village_id"
                        class="form-control form-control-sm"
                >
                  <option selected :value="''">Select a village</option>
                  <option
                          v-for="(village, index) in villages"
                          :key="index"
                          :value="village.id"
                  >{{ village.id }} : {{ village.desc }}</option
                  >
                </select>
              </div>
              <div class="col-md-6 col-sm-6 col-lg-3">
                <label for="c_mouza_id">Mouza</label>
                <select
                        v-model="search_data.c_mouza_id"
                        class="form-control form-control-sm"
                        name="c_mouza_id"
                        id="c_mouza_id"
                >
                  <option selected :value="''">Select a Mouza</option>
                  <option
                          v-for="(mouza, index) in mouzas"
                          :key="index"
                          :value="mouza.id"
                  >{{ mouza.id }} : {{ mouza.desc }}</option
                  >
                </select>
              </div>
            </div>
            <button class="btn btn-success btn-sm mt-2" @click.prevent="search">
              Search
            </button>
          </form>
        </b-card>

        <b-card>
          <div class="row mb-2">
            <div class="col-sm-12">
              <div v-if="businesses.total > 0">
                <span class="badge badge-primary">Total Search Data Found: {{ businesses.total }}</span>
                <download-excel
                        class = "btn btn-light float-right"
                        :fetch = "fetchData"
                        :fields = "business_fields"
                        :meta="json_meta"
                        worksheet = "Land"
                        name = "Business.xls">
                  Download Excel
                </download-excel>
              </div>
            </div>
          </div>
          <div class="table-responsive" style="overflow-x: auto">
            <table class="table table-centered table-striped">
              <thead>
              <tr>
                <th>#</th>
                <th>Name of Business</th>
                <th>Business Operator</th>
                <th>Father's Name</th>
                <th>Mother's Name</th>
                <th>Type of Business</th>
                <th>Address</th>
                <th>Capital</th>
                <th>Yearly Income</th>
                <th># of Employees</th>
                <th>Trade Lic no.</th>
                <th>VAT Reg. no</th>
                <th>TIN no.</th>
                <th>Deposit</th>
                <th>Village</th>
              </tr>
              </thead>
              <tbody>
              <tr li v-for="(business, index) in businesses.data" :key="business.id">
                <td>{{ businesses.from + index }}</td>
                <td>{{ business.business_name }}</td>
                <td>{{ business.operator_name }}</td>
                <td>{{ business.operator_father }}</td>
                <td>{{ business.operator_mother }}</td>
                <td>{{ business.business_type }}</td>
                <td>{{ business.address }}</td>
                <td>{{ business.capital }}</td>
                <td>{{ business.yearly_income }}</td>
                <td>{{ business.employees_no }}</td>
                <td>{{ business.trade_licensing_no }}</td>
                <td>{{ business.vat_reg_no }}</td>
                <td>{{ business.tin_no }}</td>
                <td>{{ business.advance_deposite }}</td>
                <td>{{ business.ses.village.desc }}</td>
              </tr>
              </tbody>
            </table>
            <h5 v-if="!flag  || businesses.total === 0" class="text-center text-secondary">
              No Data Found
            </h5>
          </div>
          <div class="float-right">
            <pagination :data="businesses" :limit="2" @pagination-change-page="getResults"></pagination>
          </div>
        </b-card>
      </div>
    </div>
  </Layout>
</template>

<script>
  import appConfig from "@src/app.config";
  import Layout from "@layouts/main";
  import PageHeader from "@components/page-header";
  import http from "@state/http";

  export default {
    page: {
      title: "List SES Business",
      meta: [{ name: "description", content: appConfig.description }]
    },
    components: { Layout, PageHeader },
    data() {
      return {
        title: "Search SES Business",
        items: [
          {
            text: "Dashboard",
            href: "/"
          },
          {
            text: "SES Business",
            active: true
          }
        ],
        businesses: {},
        search_data: {
          household_number: '',
          name: '',
          c_village_id: '',
          c_mouza_id: '',
        },
        villages: [],
        mouzas: [],
        business_fields: {
          'Name of Business': 'business_name',
          'Business Operator': 'operator_name',
          'Father`s Name': 'operator_father',
          'Mother`s Name': 'operator_mother',
          'Type of Business': 'business_type',
          'Address': 'address',
          'Capital': 'capital',
          'Yearly Income': 'yearly_income',
          '# of Employees': 'employees_no',
          'Trade Lic no.': 'trade_licensing_no',
          'VAT Reg. no': 'vat_reg_no',
          'TIN no.': 'tin_no',
          'Deposit': 'advance_deposite',
          'Village': 'ses.village.desc',
          'Mouza': 'ses.mouza.desc',
        },
        json_meta: [
          [
            {
              'key': 'charset',
              'value': 'utf-8'
            }
          ]
        ],
        flag: false
      };
    },

    mounted() {
      this.getCodes();
    },
    methods: {
      getCodes() {
        http.get("api/ses/codes").then(response => {
          if (!response.error) {
            let data = response.data;
            this.villages = data.villages;
            this.mouzas = data.mouzas;
          }
        });
      },
      search() {
        http.post("api/ses/business/search", this.search_data).then(response => {
          if (!response.error) {
            this.flag = true;
            this.businesses = response.data.businesses;
          }
        });
      },
      getResults(page = 1) {
        http.post('api/ses/business/search?page=' + page, this.search_data)
                .then(response => {
                  this.flag = true;
                  this.businesses = response.data.businesses;
                });
      },
      async fetchData(){
        const response = await http.post("api/ses/business/download", this.search_data);
        return response.data.businesses;
      },
    },
  };
</script>
